import { ExovaIconName } from './ExovaIconName';
export { ExovaIconName } from './ExovaIconName';
export const iconList = Object.keys(ExovaIconName).map((key) => ExovaIconName[key]);
export { Icon } from './Icon.element';
